var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    _vm._g(
      {
        staticClass: "search-result-contact",
        class: _vm.classes,
        attrs: {
          "data-bot": _vm.context
            ? "search-result__contact--" + _vm.context
            : "search-result__contact",
          href: _vm.link
        },
        on: {
          mouseenter: _vm.handleMouseEnter,
          mouseleave: function($event) {
            _vm.isHovered = false
          }
        }
      },
      _vm.$listeners
    ),
    [
      _c("CompassObject", {
        attrs: { size: "extra-small", type: "object", object: "contact" }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-result-contact__content" },
        [
          _c("h5", {
            staticClass:
              "search-result-contact__name typographies-paragraph-medium-bold",
            domProps: { innerHTML: _vm._s(_vm.name) }
          }),
          _vm._v(" "),
          _vm.companies.length > 0
            ? _c(
                "p",
                {
                  staticClass:
                    "search-result-contact__company typographies-paragraph-medium-semibold"
                },
                [
                  _c("ContactLinkedCompanies", {
                    attrs: { companies: _vm.companies }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.getHighlightedExtraFields, function(extraField, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "typographies-paragraph-medium-regular search-result-contact__extra-field"
              },
              [
                _c("span", [_vm._v(" " + _vm._s(extraField.label))]),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(extraField.value) }
                })
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }